const t = true, f = false;
const dev = f

let state = {
    dev,
    devmode: f,
    cloudurl: '',
    api: { // todo: finish adding actions and mutations to available methods
      actions: [
        {},
        { name: 'detecttype', description: 'Returns type of data', returntype: String, inputs: [] },
        { name: 'validjson', description: 'Checks if a string is valid JSON', returntype: Boolean, inputs: [String] },
        { name: 'util', description: 'Calls utility functions. payload.type should be "right, filter, if, map, set, or delete, help"', type: String, inputs: [Object] },
        { name: 'api', description: 'REST requests', returntype: Object, inputs: { verb: String, data: Object, address: String, hook: Object, config: Object } },
        { name: 'run', description: 'Runs functions and returns result (fun is the fn id)', returntype: Object, inputs: [{ fun: String, payload: Object, if: Array, hook: Object }] },
        {
          name: 'auth', description: 'Authentication functions', inputs: { type: String },
          types: {
            token: { inputs: { token: String }, description: 'Logs in with a valid token' },
            signinwithemaillink: { description: 'logs in a user from valid url' },
            email: {
              description: 'logs user in with email and password',
              inputs: { email: String, password: String }
            },
            social: { description: 'logs user in with OAUTH provider', inputs: { provider: String } },
            create: { description: 'creates new user with email and password', email: String, password: String, requirements: Object },
            reset: { description: 'sends password reset email', inputs: { email: String } },
            magiclink: { description: 'Emails a link to sign in.', inputs: { email: String } },
            completesignup: { description: 'Password creation for new users' },
            changepass: { description: 'Password change', inputs: { pass: String } },
            logout: { description: 'logs user off' },
            usercheck: { description: 'checks if an email is registered', inputs: { email: String } },
            currentuser: { description: 'returns current user', inputs: {} }
          }
        },
        {
          name: 'create', description: 'Creates content', inputs: { type: String, data: Object },
          types: {
            app: { description: 'create a new application', inputs: { type: 'app', data: { basics: Object, style: Object, pages: Object, users: Object } } },
            fromdata: { description: 'creates an item type from a data model', inputs: { data: { model: Object, name: String } } },
            msg: { description: 'creates a message', inputs: { data: { topic: String, users: Array, msgType: String, banter: { [Date.now()]: { text: String, user: String } } } } },
            notification: { description: 'creates a notification', inputs: { data: { actions: Array, subMessage: String, from: String, link: String, message: String, to: Array, type: String } } },
            comments: { description: 'creates a comment at a given resource', inputs: { comment: { id: String, text: String, type: String, user: String, timestamp: Date } } },
            reputation: { description: 'creates a reputation', inputs: { content: String, quality: Number } },
            order: { description: 'creates an order', inputs: { cart: Object, data: { Shipping: Object, Payment: Object } } },
            value: { description: 'creates a user value', inputs: { datatype: String, key: String, value: String } },
            item: { description: 'creates item', inputs: { type: String, data: Object } } // This might work as a default
          }
        }
      ],
      mutations: {}
    },
    app: {
      basics: {
        database: encodeURIComponent(window.location.hostname),
        ['app name']: encodeURIComponent(window.location.hostname),
        items: [],
        modules: [],
        api: []
      }
    },
    auth: {},
    components: {
      admin: ['admin', 'assign', 'api', 'debug', 'function', 'hooks', 'if', 'imanage', 'import', 'logs', 'pageadmin'],
      display: ['browse', 'createitem', 'foot', 'layout', 'pages', 'row', 'single'],
      instance: ["apply", "attend", "cart", "comments", "events", "jobs", "login", "media", "message", "notifications", "pointer", "reviews", "search", "smartcontract", "state"],
      views: ["admin", "auction", "completesignup", "hello", "home", "onboard", "single", "xmbl"],
      uxui: ['add', 'copy', 'icontent', 'iform', 'iiframe', 'iitem', 'ilink', 'ilist', 'iinput', 'ipage', 'islide', 'itable', 'itime', 'inav', 'rm', 'short', 'ui'],
      widgets: ['action', 'auctions', 'buy', 'completesignup', 'dashboard', 'hello', 'home', 'maps', 'navigation', 'onboard', 'orders', "profile", 'reputation', 'sales', 'terminal', 'tokens', 'user', 'wallet', "xmbl"]
    },
    connectivity: {},
    counter: 1,
    counts: {
      buy: 1,
      cart: 0,
      cheating: {},
      componentKey: 0,
      edit: 0,
      messages: 0,
      notifications: 0,
      ordersIter: 1,
      jobs: 0,
      events: 0,
      reviews: 0,
      salesIter: 1
    },
    decoded: {},
    debug: f,
    defaults: {
      userimage: '/img/stock/defaultuser.png',
      logo: ''
    },
    device: {
      language: window.navigator.language,
      mobile: 'ontouchstart' in window || navigator.msMaxTouchPoints,
      online: window.navigator.onLine,
      platform: window.navigator.platform,
      product: window.navigator.product,
      userAgent: window.navigator.userAgent,
      vendor: window.navigator.vendor
    },
    functions: {
      dispatch: {
        set: {
          desc: 'State data mutation',
          payload: { keys: Array, val: Object }
        },
        detecttype: {
          desc: 'Returns type of data',
          payload: t
        },
        validjson: {
          desc: 'Checks if a string is valid JSON',
          payload: String
        },
        util: {
          desc: 'Utility functions.',
          typerequired: t,
          payload: t,
          types: {
            right: {
              desc: 'Applies a right-side function to some data', payload: {
                item: Object, fn: String, args: Array
              }
            },
            filter: {
              desc: 'Filters an array', payload: {
                iter: Array, fn: Function
              }
            },
            if: {
              desc: 'Runs a conditional check', payload: {
                comparitor: String, conditions: Array
              }
            },
            map: { desc: 'Maps a function to items in an array', payload: { iter: Array, fn: Function } },
            set: { desc: 'Sets a value to a property in an object or to an index of an array', payload: { obj: Object, prop: String, val: Object } },
            delete: { desc: 'Removes a value from a property in an object or from an index of an array', payload: { obj: Object, prop: String } },
            qr: { desc: 'Removes a value from a property in an object or from an index of an array', payload: { obj: Object, prop: String } }
          }
        },
        api: {
          desc: 'Hits RESTful endpoints. Verb must be type of get, post, delete, or patch.',
          payload: { verb: String, data: Object, address: String, hook: Object, config: Object }
        },
        if: {
          desc: 'Checks some conditions',
          payload: {item: Object, data: Object, conditions: Array, name: String}
        },
        run: {
          desc: 'Function runner',
          payload: { fun: Object, payload: Object, if: Array, hook: Object }
        },
        auth: {
          desc: 'Authentication functions',
          typerequired: t,
          payload: t,
          types: {
            token: { desc: 'Logs in with a valid token', payload: { token: String } },
            signinwithemaillink: { desc: 'logs in a user from valid url' },
            email: {
              desc: 'logs user in with email and password',
              payload: { email: String, password: String }
            },
            social: { desc: 'logs user in with OAUTH provider', payload: { provider: String } },
            create: { desc: 'creates new user with email and password', email: String, password: String, requirements: Object },
            reset: { desc: 'sends password reset email', payload: { email: String } },
            magiclink: { desc: 'Emails a link to sign in.', payload: { email: String } },
            completesignup: { desc: 'Password creation for new users' },
            changepass: { desc: 'Password change', payload: { pass: String } },
            logout: { desc: 'logs user off' },
            usercheck: { desc: 'checks if an email is registered', payload: { email: String } },
            currentuser: { desc: 'returns current user' }
          }
        },
        create: {
          desc: 'Create items and app content',
          typerequired: t,
          types: {
            app: { desc: 'create a new application', payload: { data: { basics: Object, style: Object, pages: Object, users: Object } } },
            fromdata: { desc: 'creates an item type from a data model', payload: { data: { model: Object, name: String } } },
            msg: { desc: 'creates a message', payload: { data: { topic: String, users: Array, msgType: String, banter: { [Date.now()]: { text: String, user: String } } } } },
            notification: { desc: 'creates a notification', payload: { data: { actions: Array, subMessage: String, from: String, link: String, message: String, to: Array, type: String } } },
            comments: { desc: 'creates a comment at a given resource', payload: { comment: { id: String, text: String, type: String, user: String, timestamp: Date } } },
            reputation: { desc: 'creates a reputation', payload: { content: String, quality: Number } },
            order: { desc: 'creates an order', payload: { cart: Object, data: { Shipping: Object, Payment: Object } } },
            value: { desc: 'creates a user value', payload: { datatype: String, key: String, value: String } },
            item: { desc: 'creates item', payload: { type: String, data: Object } } // TODO check if this might work as a default
          }
        },
        query: {
          desc: 'Gets data associated with an item or app content.',
          typerequired: t,
          types: {
            list: {
              desc: 'Gets a collection of items', payload: {
                collection: String, limit: Number
              }
            },
            item: {
              desc: 'Gets a specific item', payload: {
                collection: String, id: String
              }
            },
            reputation: {
              desc: 'Gets a reputation entry', payload: { id: String }
            },
            user: {
              desc: 'Gets user data', payload: { id: String }
            },
          }
        },
        update: {
          desc: 'Update items and app content',
          typerequired: t,
          types: {
            app: { desc: 'Update application', payload: { data: { basics: Object, style: Object, pages: Object, users: Object } } },
            msg: { desc: 'Updates a message', payload: { data: { topic: String, users: Array, msgType: String, banter: { [Date.now()]: { text: String, user: String } } } } },
            notification: { desc: 'creates a notification', payload: { data: { actions: Array, subMessage: String, from: String, link: String, message: String, to: Array, type: String } } },
            comments: { desc: 'creates a comment at a given resource', payload: { comment: { id: String, text: String, type: String, user: String, timestamp: Date } } },
            reputation: { desc: 'creates a reputation', payload: { content: String, quality: Number } },
            order: { desc: 'creates an order', payload: { cart: Object, data: { Shipping: Object, Payment: Object } } },
            value: { desc: 'creates a user value', payload: { datatype: String, key: String, value: String } },
            item: { desc: 'creates item', payload: { type: String, data: Object } } // TODO check if this might work as a default
          }
        },
        delete: {
          desc: 'Deletes items and app content',
          payload: { id: String, type: String }
        },
        relate: {},
        token: {},
        transact: {},
        upload: {},
        import: {},
        export: {},
        secrets: {
          desc: 'Manages secrets',
          typerequired: t,
          types: {
            share: {
              desc: 'Splits a secret',
              payload: { str: String, shares: Number, thresh: Number }
            },
            combine: {
              desc: 'Combines shares',
              payload: { shares: Array }
            }
          }
        }
      },
      commit: {
        set: {
          desc: 'Sets some value to some state location',
          payload: { keys: Array, val: Object }
        }
      }
    },
    iitem: {},
    isEmail: f,
    lastuploadurls: [],
    lastuploadhash: [],
    ref: {
      image: {},
      name: {},
      title: {}
    },
    related: {
      connect: {},
      data: {},
      events: {},
      jobs: {}
    },
    scrollVal: 0,
    search: {
      item: '',
      artist: ''
    },
    secretEvent: f,
    secretItem: f,
    show: {},
    userExists: f,
    version: '1',
    welcomeNotificationSent: f,
    windowHeight: window.innerHeight,
    windowWidth: window.innerWidth,
  }

  export default state